<template>
    <div style="width: 500px">
        <!-- 流量分配线段 -->
        <div ref="sliderContainer" style="position: relative; height: 60px;">
            <!-- 基础线段 -->
            <div style="position: absolute; top: 30px; left: 0; right: 0; height: 2px; background-color: #e8eaec;">
            </div>

            <!-- 已分配线段 -->
            <div style="position: absolute; top: 30px; left: 0; height: 2px; background-color: #2d8cf0;"
                :style="{ width: '100%' }"></div>

            <!-- 滑块组 -->
            <div style="position: absolute; top: 0; left: 0; right: 0; height: 60px;">
                <!-- 左侧起始点 -->
                <div
                    style="position: absolute; top: 25px; left: 0; transform: translateX(-50%); width: 12px; height: 12px; border-radius: 50%; background-color: #fff; border: 2px solid #2d8cf0; cursor: pointer;pointer-events: none;">
                </div>
                <div
                    style="position: absolute; top: 45px; left: 0; transform: translateX(-50%); font-size: 12px; white-space: nowrap;">
                    0%
                </div>

                <!-- 分组滑块 -->
                <div v-for="(group, index) in groups.slice(0, -1)" :key="index"
                    style="position: absolute; top: 25px; transform: translateX(-50%); width: 12px; height: 12px; border-radius: 50%; background-color: #2d8cf0; border: 2px solid #fff; box-shadow: 0 0 0 1px #2d8cf0; cursor: pointer;"
                    :style="{ left: getSliderPosition(index) + '%' }" @mousedown="startDrag(index, $event)"
                    class="traffic-slider"></div>

                <!-- 右侧结束点 -->
                <div
                    style="position: absolute; top: 25px; right: 0; transform: translateX(50%); width: 12px; height: 12px; border-radius: 50%; background-color: #fff; border: 2px solid #2d8cf0; cursor: pointer;pointer-events: none;">
                </div>
                <div
                    style="position: absolute; top: 45px; right: 0; transform: translateX(50%); font-size: 12px; white-space: nowrap;">
                    100%
                </div>
            </div>

            <!-- 分组标签 -->
            <div
                style="position: absolute; top: 0; left: 0; right: 0; height: 25px; display: flex; justify-content: space-between;">
                <div v-for="(group, index) in groups" :key="index" style="text-align: center; font-size: 12px;"
                    :style="{ width: group.percent + '%', left: getGroupLabelLeft(index) + '%' }">
                    {{ group.name }}
                </div>
            </div>

            <!-- 百分比标签 -->
            <div
                style="position: absolute; top: 45px; left: 0; right: 0; height: 15px; display: flex; justify-content: space-between;">
                <div v-for="(group, index) in groups" :key="index" style="text-align: center; font-size: 12px;"
                    :style="{ width: group.percent + '%', left: getGroupLabelLeft(index) + '%' }">
                    {{ group.percent }}%
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TrafficDistribution',
    props: {
        // v-model 绑定的值：各个段的百分比数组
        value: {
            type: Array,
            default: () => [50, 50]
        },
        // 分组名称列表（可选）
        groupNames: {
            type: Array,
            default: () => ['对照组', '实验组 1']
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        // 监听value变化，更新分组
        value: {
            handler(newValue) {
                this.updateGroups(newValue)
            },
            immediate: true,
            deep: true
        }
    },
    data() {


        return {
            // 分组数据
            groups: [],
            // 当前拖动的滑块索引
            draggingIndex: -1,
            // 拖动起始鼠标X坐标
            startMouseX: 0,
            // 初始分组A百分比
            startPercentA: 0,
            // 初始分组B百分比
            startPercentB: 0,
            // 容器引用
            containerRef: null
        }
    },
    mounted() {
        // 添加全局事件监听
        document.addEventListener('mousemove', this.handleMouseMove)
        document.addEventListener('mouseup', this.handleMouseUp)
    },
    beforeDestroy() {
        // 移除全局事件监听
        document.removeEventListener('mousemove', this.handleMouseMove)
        document.removeEventListener('mouseup', this.handleMouseUp)
    },
    methods: {

        // 获取滑块位置（前n个分组的百分比总和）
        getSliderPosition(index) {
            let position = 0
            for (let i = 0; i <= index; i++) {
                position += this.groups[i].percent
            }
            return position
        },

        // 更新分组数据
        updateGroups(percentages) {
            // 确保percentages是数组
            if (!Array.isArray(percentages)) {
                percentages = [50, 50]
            }
            
            // 初始化分组
            const groups = []
            
            // 使用传入的百分比数组
            for (let i = 0; i < percentages.length; i++) {
                groups.push({
                    name: this.groupNames[i] || (i === 0 ? '对照组' : `实验组 ${i}`),
                    percent: percentages[i]
                })
            }
            
            this.groups = groups
        },

        // 获取分组标签的左侧位置
        getGroupLabelLeft(index) {
            let left = 0
            for (let i = 0; i < index; i++) {
                left += this.groups[i].percent
            }
            return left
        },

        // 开始拖动
        startDrag(index, event) {
            if(this.disabled) return
            this.draggingIndex = index
            this.startMouseX = event.clientX

            // 保存初始百分比
            this.startPercentA = this.groups[index].percent
            this.startPercentB = this.groups[index + 1].percent

            event.preventDefault()
        },

        // 处理鼠标移动
        handleMouseMove(event) {
            if(this.disabled) return
            if (this.draggingIndex === -1) return

            // 获取滑块容器
            const container = this.$refs.sliderContainer
            if (!container) return

            const containerRect = container.getBoundingClientRect()
            const containerWidth = containerRect.width

            // 计算鼠标位置相对于容器的百分比（整个滑块范围）
            const mouseX = event.clientX - containerRect.left
            const totalPercent = Math.max(0, Math.min(100, (mouseX / containerWidth) * 100))

            // 计算当前滑块左侧的总百分比
            let leftTotalPercent = 0
            for (let i = 0; i < this.draggingIndex; i++) {
                leftTotalPercent += this.groups[i].percent
            }

            // 计算当前滑块位置对应的分组A和分组B的新百分比
            const availablePercent = this.startPercentA + this.startPercentB
            const newPercentA = Math.max(0, Math.min(availablePercent, totalPercent - leftTotalPercent))
            const newPercentB = availablePercent - newPercentA

            // 更新分组百分比
            const updatedGroups = [...this.groups]
            updatedGroups[this.draggingIndex].percent = Math.round(newPercentA)
            updatedGroups[this.draggingIndex + 1].percent = Math.round(newPercentB)
            
            // 更新本地groups数据
            this.groups = updatedGroups
            
            // 提取百分比数组，触发v-model更新
            // const percentages = updatedGroups.map(group => group.percent)
            this.$nextTick(()=>{
                this.$emit('change', updatedGroups)
            })
        },

        // 结束拖动
        handleMouseUp() {
            if(this.disabled) return
            this.draggingIndex = -1
        },
    }
}
</script>

<style scoped lang="less">
.layout-card {
    /deep/ .ivu-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}
</style>